import { useSetAtom } from 'jotai'
import { usePhase } from './usePhase'
import { updatePriceArrCalculation } from '../atoms/reviewPricing.atoms'
import { ArrCalculation } from '../atoms/reviewPricing.primitives.atoms'

export const usePriceArrCalculation = (props: {
  phaseId: string
  priceId: string
}) => {
  const updateArrCalculation = useSetAtom(updatePriceArrCalculation)
  const { phase } = usePhase(props.phaseId)
  const existingPriceMetadata = phase.phasePriceMetadata.find(
    metadata => metadata.priceId === props.priceId
  )

  return {
    value: existingPriceMetadata?.arrCalculation ?? 'INCLUDE',
    update: (newValue: ArrCalculation) =>
      updateArrCalculation({
        phaseId: props.phaseId,
        priceId: props.priceId,
        newValue
      })
  }
}
